import React from "react";
import { motion } from "framer-motion";

import styles from "./styles.module.scss";

// components
import Form from "../Form";
import HomeSlider from "../AdvertismentSlider/AdvertismentSlider";

const DesktopFilter = () => {
  return (
    <div className={styles.desktop__filter__wrapper}>
      <motion.div
        initial={{ opacity: 0, x: -100 }}
        animate={{ opacity: 1, x: 0 }}
      >
        <Form />
      </motion.div>
      <motion.div
        initial={{ opacity: 0, x: 100 }}
        animate={{ opacity: 1, x: 0 }}
      >
        <HomeSlider />
      </motion.div>
    </div>
  );
};

export default DesktopFilter;
